module.exports = __webpack_public_path__ + "static/schaffhauser-nachrichten-4208352635e0ade31c8c0402d3f6d05c.png";